import {HttpService} from "../http/HttpService";
import {
    AdNetworkDestination,
    AdNetworkEventType,
    AdNetworkLogListRequest,
    AdNetworkLogListResponse,
    AdNetworkTestResult
} from "../http/protocol";

export class AdNetworkService {

    constructor(private http: HttpService) {
    }

    listDestinations(): Promise<AdNetworkDestination[]> {
        return this.http.get("/ad-networks");
    }

    getDestination(id: number): Promise<AdNetworkDestination> {
        return this.http.get(`/ad-networks/${id}`);
    }

    createDestination(destination: AdNetworkDestination): Promise<AdNetworkDestination> {
        return this.http.post("/ad-networks", destination);
    }

    updateDestination(id: number, destination: AdNetworkDestination): Promise<AdNetworkDestination> {
        return this.http.put(`/ad-networks/${id}`, destination);
    }

    deleteDestination(id: number): Promise<{}> {
        return this.http.delete(`/ad-networks/${id}`);
    }

    sendTestCallback(id: number, eventType: AdNetworkEventType): Promise<AdNetworkTestResult> {
        return this.http.post(`/ad-networks/${id}/test/${eventType}`, {});
    }

    listLogs(request: AdNetworkLogListRequest): Promise<AdNetworkLogListResponse> {
        return this.http.post("/ad-networks/log/list", request);
    }
}
